export const LINKS = {
    telegram: "https://t.me/visper_news",
};

export const YANDEX_METRIKA_ID = 98778399;
